module.exports = __webpack_public_path__ + "img/stellenanzeigen-de.02a418d.svg";